// extracted by mini-css-extract-plugin
module.exports = {"paginationNav":"pagination_paginationNav__hg1i-"};